const getColor = () => {
  let colors = {
    0: "#673ab7",
    1: "#03a9f4",
    2: "#000000",
    3: "#f44336",
    4: "#e91e63",
    5: "#9c27b0",
    6: "#3f51b5",
    7: "#2196f3",
    8: "#00bcd4",
    9: "#009688",
    10: "#4caf50",
    11: "#607d8b",
    12: "#795548",
    13: "#ff5722",
    14: "#e53935",
    15: "#d81b60",
    16: "#8e24aa",
    17: "#5e35b1",
    18: "#ff5252",
    19: "#ff4081",
    20: "#e040fb",
    21: "#7c4dff",
    22: "#3f51b5",
    23: "#1565c0",
    24: "#01579b",
    25: "#006064",
    26: "#558b2f",
    27: "#2e7d32",
    28: "#00695c",
    29: "#827717",
    30: "#e65100",
    31: "#bf360c",
    32: "#d84315",
    33: "#3e2723",
    34: "#424242",
    35: "#37474f",
    36: "#dd2c00",
  };
  return colors[Math.floor(Math.random() * 36).toString()];
};
export default getColor;
